import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-service-details',
  templateUrl: './on-grid-solar.component.html',
  styleUrls: ['./on-grid-solar.component.scss']
})
export class OnGridSolarComponent implements OnInit {

  constructor(private titleService: Title) { }
  
    ngOnInit() {
       this.titleService.setTitle('On Grid Solar');
    }

}
